module.exports = __webpack_public_path__ + "static/img/rec2.fc6752e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rec2.png
// module id = 1lh0
// module chunks = 1